import { computed, Ref } from "@vue/composition-api";
import {
  CreatorService,
  InputCreatorServiceCreate,
  InputCreatorServiceSearch,
  InputCreatorServiceUpdate,
} from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";

export const useCreatorServices = (data: Ref<InputCreatorServiceSearch>) => {
  const {
    items,
    data: responseResult,
    enableScroll,
    addItem,
    removeItem,
    updateItem,
    getFirstPage,
    getNextPage,
  } = usePager<CreatorService, InputCreatorServiceSearch>(page =>
    providers.CreatorServicesProvider.search({
      data: {
        ...data.value,
        page,
      },
    })
  );

  const totalRecords = computed(() => responseResult.value?.totalRecords ?? 0);

  const create = async (data: InputCreatorServiceCreate) => {
    const response = await providers.CreatorServicesProvider.create({
      data,
    });
    addItem(response, "start");
    return response;
  };

  const update = async (data: InputCreatorServiceUpdate) => {
    const response = await providers.CreatorServicesProvider.update({
      data,
    });
    updateItem(response, i => i.id === data.id);
    return response;
  };

  const remove = async (id: string) => {
    await providers.CreatorServicesProvider.delete(id);
    await removeItem(i => i.id === id);
  };

  return {
    items,
    enableScroll,
    totalRecords,
    getFirstPage,
    getNextPage,
    create,
    update,
    remove,
    updateItem,
  };
};
